import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ListicleEvents.css';
import React from 'react';
import { parse } from 'node-html-parser';
import { get, getFormatedDate, getGlobalDictionaryTerm, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { commonStyles as commonComponentStyles, rtlStyles, ltrStyles } from '../77_ListicleItem/ListicleItem';
import { ReactComponent as IconLocation } from '../../resources/icons/ReskinIconPin.svg';
import { ReactComponent as IconCalendar } from '../../resources/icons/calendar.svg';
import RouterLink from '../atoms/RouterLink';
// import Truncate from 'react-truncate';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import { renderRTListSchema, getListsTexts } from '../../utils/seo';
import TruncateMarkup from 'react-truncate-markup';
import ReactHtmlParser from 'react-html-parser';
// import IconChevronLeftLight from '../../resources/icons/IconChevronLeftLight.svg';

export var ListicleEvents = function ListicleEvents(_ref) {
  var fields = _ref.fields,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 1 : _ref$index,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var businessSite = get(sitecoreContext, 'site.name') === 'business';
  var currentLang = get(sitecoreContext, 'language');
  var moduleId = get(fields, 'data.item.id');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var infoRef = React.useRef(null);
  var _React$useState = React.useState(1100),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    truncateWidth = _React$useState2[0],
    settruncateWidth = _React$useState2[1];
  var enablingReadMore = get(fields, 'data.item.enablingReadMore.jss.value');
  var _React$useState3 = React.useState(enablingReadMore),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isTruncated = _React$useState4[0],
    setisTruncated = _React$useState4[1];
  var dictionaryValues = get(fields, 'data.moduleDictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isVdsite = _React$useState6[0],
    setIsVdsite = _React$useState6[1];
  var _React$useState7 = React.useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    componentListsSchema = _React$useState8[0],
    setComponentListsSchema = _React$useState8[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(function () {
    if (truncateWidth < 769) {
      setisTruncated(true);
    }
  }, [truncateWidth]);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var variables = ColorHex ? {
    "--m77-listicle-events-background-color": BackgroundColorHex,
    "--m77-listicle-events-color": ColorHex
  } : {
    "--m77-listicle-events-background-color": selectedPrimaryColor,
    "--m77-listicle-events-color": getColorByTheme(selectedPrimaryColor)
  };
  var _fields$data = fields.data,
    videoAnalytics = _fields$data.videoAnalytics,
    prevNextNavAnalytics = _fields$data.prevNextNavAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    readMoreAnalytics = _fields$data.readMoreAnalytics;
  React.useEffect(function () {
    setTimeout(function () {
      if (infoRef.current) {
        settruncateWidth(infoRef.current.offsetWidth);
      }
    }, 1000);
  }, [fields]);
  var itemTitle = get(fields, 'data.item.title.jss.value');
  var favBtnItemId = get(fields, 'data.item.pOI.targetItem.id');
  var targetUrl = get(fields, 'data.item.url') || '/';
  var number = get(fields, 'data.item.number.jss');
  var hasFallbackImage = Boolean(get(fields, 'data.item.fallbackImage.jss.value.src'));
  var itemFallbackImage = get(fields, 'data.item.fallbackImage.jss.value.src');
  var itemFallbackImageCaption = get(fields, 'data.item.fallbackImage.jss.value.alt');
  var itemIntroText = Boolean(get(fields, 'data.item.introText.jss.value'));
  var itemCategory = get(fields, 'data.item.category.value.title.jss.value');
  // const hasVideoSrc: boolean = Boolean(get(fields, 'data.item.media.jss.value.href'));
  // const videoSrc = get(fields, 'data.item.media.jss.value.href');
  var videoSrc = get(fields, 'data.item.media.jss.value.href');
  var videoType = get(fields, 'data.item.media.jss.value.linktype');
  if (videoSrc === 'http://' || videoSrc === 'https://') {
    videoSrc = '';
  }
  var GooglePlaceID = get(fields, 'data.item.googlePlaceID.jss.value'); // eslint-disable-line
  var GooglePlaceLat = get(fields, 'data.item.latitude.jss.value');
  var GooglePlaceLong = get(fields, 'data.item.longitude.jss.value');
  var googleMapLatLongUrl = 'https://www.google.com/maps/search/?api=1&query=';
  var GooglePlace = googleMapLatLongUrl + GooglePlaceLat + ',' + GooglePlaceLong;
  var eventDateString = get(fields, 'data.item.eventDates.jss.value');
  var intro = get(fields, 'data.item.intro.jss');
  var address = get(fields, 'data.item.address.jss.value');
  var eventDates = Boolean(eventDateString) ? JSON.parse(eventDateString).dates : [];
  var eventItemDate = eventDates.map(function (date, index) {
    return getFormatedDate(date, currentLang, true);
  });
  React.useEffect(function () {
    var dom = intro ? parse(intro.value) : undefined;
    var rtLists = getListsTexts(dom);
    if (rtLists.length) setComponentListsSchema(rtLists);
  }, []);
  if (!fields) {
    console.info('ListicleItemEvent component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ListicleItemEvent component is empty: please provide datasource]");
    }
    return null;
  }
  var renderMedia = function renderMedia() {
    if (!hasFallbackImage) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-outer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "listicle__media-inner listicle__media-inner--poster-show"
    }, /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: "listicle__image-box"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:1200px)",
      srcSet: itemFallbackImage + '&cw=1420&ch=710'
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width:769px)",
      srcSet: itemFallbackImage + '&cw=1180&ch=590'
    }), /*#__PURE__*/React.createElement("source", {
      media: "(max-width:768px)",
      srcSet: itemFallbackImage + '&cw=325&ch=243'
    }), /*#__PURE__*/React.createElement("img", {
      src: itemFallbackImage + '&cw=1420&ch=710',
      className: "listicle__img",
      alt: "".concat(itemFallbackImageCaption)
    })), videoSrc && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      className: "media-wrapper__video ",
      videoType: videoType,
      videoSrc: videoSrc,
      click: function click(e) {
        return tealiumClickFunc(tealiumMergeClickData(videoAnalytics, params), [e, getLastPartInURL(videoSrc)]);
      }
    }), /*#__PURE__*/React.createElement(FavouriteBtn, {
      itemId: moduleId,
      classes: ' listicle__fav-btn'
    }))), /*#__PURE__*/React.createElement("div", {
      className: "listicle__caption body-small"
    }));
  };
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__item"
  }, number && /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    className: "listicle__tag ".concat(businessSite ? 'listicle__tag--business' : ''),
    field: number,
    "data-cy": "number"
  }), itemIntroText && /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "h2 listicle__title",
    field: fields.data.item.introText.jss,
    "data-cy": "listicle__title"
  }), /*#__PURE__*/React.createElement("div", {
    className: "listicle__media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: "listicle__info ".concat(!itemFallbackImageCaption ? 'listicle__info--no-caption' : '')
  }, /*#__PURE__*/React.createElement("div", {
    ref: infoRef,
    className: "listicle__info-text"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "".concat(truncateWidth, "px")
    }
  }, isTruncated ? /*#__PURE__*/React.createElement("div", {
    className: "truncated-copy"
  }, /*#__PURE__*/React.createElement(TruncateMarkup, {
    lines: 3,
    ellipsis: /*#__PURE__*/React.createElement("span", {
      className: "read-more"
    }, "... ", /*#__PURE__*/React.createElement("b", {
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: function onClick() {
        setisTruncated(false);
        tealiumClickFunc(tealiumMergeClickData(readMoreAnalytics, params), [getLastPartInURL(fields.data.item.introText.jss.value)]);
      },
      className: ""
    }, mapDictionary.get('ReadMore'), /*#__PURE__*/React.createElement(IconChevronRightLight, null)))
  }, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, ReactHtmlParser(intro && intro.value)))))), /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-info"
  }, itemTitle && /*#__PURE__*/React.createElement(RouterLink, {
    href: targetUrl,
    title: "".concat(itemTitle),
    "data-cy": "listicle__item-link",
    className: "listicle__item-link body-large listicle__bottom-title"
  }, itemTitle), itemCategory && /*#__PURE__*/React.createElement("div", {
    className: "listicle__bottom-small"
  }, fields.data.item.category.value.title.jss.value), /*#__PURE__*/React.createElement("ul", {
    className: "listicle__list"
  }, eventDateString && /*#__PURE__*/React.createElement("li", {
    className: "listicle__list-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconCalendar, null)), eventItemDate[0], eventItemDate[0] === eventItemDate[1] ? '' : ' - ' + eventItemDate[1]), address && /*#__PURE__*/React.createElement("li", {
    className: "listicle__list-item"
  }, GooglePlaceLat && GooglePlaceLong && GooglePlace ? /*#__PURE__*/React.createElement("a", {
    href: "".concat(GooglePlace),
    target: "_blank",
    rel: "noopener noreferrer",
    title: "".concat(address, " | ").concat(newWindowLabel)
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "listicle__list-icon"
  }, /*#__PURE__*/React.createElement(IconLocation, null)), /*#__PURE__*/React.createElement("span", {
    className: "listicle__tag-text"
  }, address))))))), componentListsSchema.map(function (listSchema) {
    return renderRTListSchema(listSchema);
  }));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonComponentStyles, " ").concat(commonStyles, " ").concat(truncateStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var truncateStyles = "t1cvpp0g";
var commonStyles = "cl5y3rb";
export default ListicleEvents;